import { Stack } from 'expo-router';
import { useMemo } from 'react';

import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';

export default function RedeemLayout() {
  const { isAuthenticated } = useAuthContext();
  const isRewardsTiersEnabled = useFlag('enable-rewards-tiers')

  const options = useMemo(
    () =>
      isRewardsTiersEnabled
        ? ({
            presentation: 'containedTransparentModal',
            headerShown: false,
            contentStyle: { backgroundColor: 'transparent' },
            animation: 'slide_from_bottom',
          } as const)
        : ({
            header: getScreenTitleHeader({ backStyle: isAuthenticated ? 'back' : 'close' }),
            presentation: isAuthenticated ? undefined : 'fullScreenModal',
            animation: isAuthenticated ? 'slide_from_right' : 'slide_from_bottom',
          } as const),
    [isRewardsTiersEnabled, isAuthenticated]
  );
  return (
    <Stack>
      <Stack.Screen name="index" options={options} />
    </Stack>
  );
}
